import {isEqual, omit} from 'lodash';

import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {ApiTokenModel} from '../../../models/api/apiTokenModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {ApiTokenActionsEnum} from './apiTokensActions';

const apiTokensUpdatedReducer = createResourcesUpdatedReducer(
  'apiTokens',
  (apiToken) => apiToken.id,
  mergeApiTokens,
);

export function apiTokensReducer(
  state: ResourceMap<ApiTokenModel>,
  action: AppAction,
): ResourceMap<ApiTokenModel> {
  switch (action.type) {
    case DataGroupsActionsEnum.DATA_UPDATED:
      return apiTokensUpdatedReducer(state, action);

    case ApiTokenActionsEnum.API_TOKEN_DELETED:
      return omit(state, action.payload);

    default:
      return state;
  }
}

function mergeApiTokens(existingApiToken: ApiTokenModel | undefined, updatedApiToken: ApiTokenModel) {
  if (!existingApiToken) {
    return updatedApiToken;
  }

  if (isEqual(existingApiToken, updatedApiToken)) {
    return existingApiToken;
  }

  return updatedApiToken;
}
